"use strict";

/**
 *	Konstruktor
 */
gc.gis.module.GCLink3DViewer = function(options)
{
	gc.gis.module.GCAbstractModule.call(this, options);

	this.label = options.label || '3D-Ansicht starten';
	/**
	 * @type {gc.gis.map.GCMapView} Karteninstanz
	 * @private
	 */
	this._map = options.map || gc.gis.iface.map;
	/**
	 * @type {gc.gis.factory.ObjectFactory}
	 * @private
	 */
	this._mapFactory = gc.gis.iface.mapFactory;
	/**
	 * @type {string}
	 * @private
	 */
	this._url = gc.gis.GCUrl.fromString(options.viewerUrl);
	/**
	 * @type {string}
	 * @private
	 */
	this._target = options.viewerTarget || '_blank';
	/**
	 * @type {number|undefined}
	 * @private
	 */
	this._maxScaledenom = options.viewerMaxScaledenom;
	/**
	 * @type gc.gis.widget.GCItem
	 */
	this._btn = null;

	if (options.viewerUrl)
	{
		this._render();
		this._initEvents();
		gc.gis.iface.ui.mapToolbarZoom.addItem(this._btn);
	}
};
gc.gis.module.GCLink3DViewer.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);

/**
 * @private
 */
gc.gis.module.GCLink3DViewer.prototype._initEvents = function()
{
	var self = this;
	this._map.on(gc.gis.map.GCMapEvent.SCALE_CHANGED, this, function(evt)	{
		self._updateButton();
	});
};

/**
 * @return {jQuery}
 * @private
 */
gc.gis.module.GCLink3DViewer.prototype._render = function()
{
	var self = this;

	this._btn = new gc.gis.widget.GCItem({
		tooltip: this.label,
		className: 'gc-map-control-button',
		containerClassName: 'gc-map-control gc-map-control-3dviewer',
		label: '3D',
		click: function () {
			try
			{
				if (this.isEnabled())
				{
					self._startViewer();
				}
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});
	this._updateButton();

	this.element = this._btn.getElement();
	return this.element;
};

gc.gis.module.GCLink3DViewer.prototype._updateButton = function()
{
	if (this._btn && undefined !== this._maxScaledenom && 0 < this._maxScaledenom )
	{
		if (this._map.getScale() <= this._maxScaledenom)
		{
			this._btn.setEnabled(true);
			this._btn.setActive(true);
			this._btn.setTooltip(this.label)
		}
		else
		{
			this._btn.setEnabled(false);
			this._btn.setActive(false);
			this._btn.setTooltip(this.label + ' (ab 1:' + this._maxScaledenom.toLocaleString() + ' verfügbar)');
		}
	}
};

gc.gis.module.GCLink3DViewer.prototype._startViewer = function()
{
	// Hinweis: Winkelangaben erwartet der 3D-Viewer in Gon
	var coord = [],
		cameraPos = this._mapFactory.createPoint(),
		sourceCrs = this._map.getProjection(),
		targetCrs = 'EPSG:25833',                               // ZielCRS des 3D-Viewers
		viewport = this._map.getViewportExtent(),
		mapSize = this._map.getSize(),
		ver = this._url.queryObject.ver || 70,                  // vertikaler Blickwinkel aus URL nehmen oder per Default 70
		hor = -gc.gis.GCUtil.degToGon(this._map.getRotation()), // horizontaler Blickwinkel
		params;

	// in Ziel-CRS des Viewer transformieren
	viewport = this._map.transformExtent(viewport, sourceCrs, targetCrs);
	cameraPos.setCRS(sourceCrs);

	// Kameraposition berechnen
	if (ver >= 100)
	{
		// Standpunkt der Kamera ist die Kartenmitte (volle Draufsicht)
		coord = this._map.getCenter();
	}
	else
	{
		// Standpunkt der Kamera ist die Mitte am unteren Bildschirmrand
		coord = this._map.pixelToWorld([mapSize[0] / 2, mapSize[1]]);
	}

	// Höhe über rechtwinkliges Dreieck ermitteln (Heuristik): Annahme rechtwinkliges Dreick mit alpha und beta je 45°
	// passt zwar nur für den Fall, dass man ein volle Draufsicht hat genau ist aber ansonsten auch in Näherung OK
	coord[2] = Math.max(gc.gis.GCExtent.getWidth(viewport), gc.gis.GCExtent.getHeight(viewport)) / 2;
	coord[2] = Math.max(coord[2], 35);

	cameraPos.setXYZ(coord[0], coord[1], coord[2]);
	cameraPos.project(targetCrs);

	if (ver < 70)
	{
		// durch die Neigung muss der Blickpunkt in y etwas verschoben werden (die halbe Höhe ist eine Heuristik)
		coord[1] -=  coord[2]/2;
	}

	params = {
		x: Math.round(cameraPos.getX()),
		y: Math.round(cameraPos.getY()),
		z: Math.round(cameraPos.getZ()),
		hor: Math.round(hor),
		ver: Math.round(ver)
	};

	window.open(gc.gis.GCUrl.toString(this._url, params), this._target);
};
